var UPC = {};
export {
  UPC as __exports
};
//# sourceMappingURL=index195.js.map
